"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_jss_1 = require("react-jss");
const deepmerge_1 = __importDefault(require("deepmerge"));
const spacing_1 = require("./spacing");
const shadows_1 = require("./shadows");
const shape_1 = require("./shape");
const palette_1 = require("./palette");
const typography_1 = require("./typography");
const transition_1 = require("./transition");
const zIndex_1 = require("./zIndex");
exports.defaultTheme = {
    spacing: spacing_1.createSpacing(12),
    palette: palette_1.createPalette({
        default: '#3f3f3f',
        primary: '#f44336',
        secondary: '#607d8b',
        textPrimary: '#000000',
        textSecondary: '#a7a7a7',
        textLight: '#ffffff',
        success: '#02bb44',
        error: '#cc0000',
        warning: '#fda50d',
        border: '#d8d8d8',
        background: '#f3f4f8',
        surface: '#ffffff',
    }),
    typography: typography_1.defaultTypography,
    shadows: shadows_1.defaultShadows,
    shape: shape_1.defaultShape,
    transition: transition_1.defaultTransition,
    zIndex: zIndex_1.defaultZIndex,
};
exports.createTheme = (options = exports.defaultTheme) => deepmerge_1.default(exports.defaultTheme, options);
exports.ThemeProvider = react_jss_1.ThemeProvider;
function withTheme(Component) {
    return react_jss_1.withTheme(Component);
}
exports.withTheme = withTheme;
function useTheme() {
    return react_jss_1.useTheme();
}
exports.useTheme = useTheme;
